const variants = {
    final: { opacity: 1, x: 0 },
    entryFromRight: { x: 90, opacity: 0 },
    entryFromLeft: { x: -90, opacity: 0 },
    entryInitial: { opacity: 0 },
};

export default variants;
